<div class="flex justify-content-end mb-2">
  <button
    pButton
    type="button"
    data-testid="member-row-csv"
    class="p-button-sm p-button-outlined"
    pTooltip="見えている行をCSVで保存します（エクセルでそのまま開けます）"
    tooltipPosition="left"
    (click)="downloadCsv()">
    <i
      class="pi pi-download"
      aria-hidden="true"></i>
    エクセル用CSV
  </button>
</div>
<p-table
  showGridlines
  [value]="filteredRows"
  dataKey="key"
  [tableStyle]="{ 'min-width': '50rem' }"
  [paginator]="filteredRows.length > 30"
  [rows]="30">
  <ng-template #header>
    <tr>
      <th width="6%">画像</th>
      <th width="12%">Keepaグラフ</th>
      <th width="20%">JAN / ASIN</th>
      <th width="14%">
        Amazon価格
        <br />
        仕入値
      </th>
      <th
        width="10%"
        pTooltip="FBAで売った場合。利益額 = Amazon価格 − 販売手数料 − FBA配送手数料 − 仕入値、利益率 = 利益額 ÷ Amazon価格"
        tooltipPosition="top">
        利益額
        <br />
        利益率
      </th>
      <th>商品名</th>
    </tr>
  </ng-template>
  <ng-template
    #body
    let-m>
    <tr>
      <td>
        @if (m.asin && m.imageUrl) {
          <a
            [href]="'https://www.amazon.co.jp/dp/' + m.asin"
            target="_blank">
            <img
              [src]="m.imageUrl"
              style="width: 50px" />
          </a>
        }
      </td>
      <td>
        @if (m.asin) {
          <app-keepa-graph [asin]="m.asin"></app-keepa-graph>
        }
      </td>
      <td>
        {{ m.jan }}
        @if (m.asin) {
          <br />
          {{ m.asin }}
        }
        @for (d of m.details; track d) {
          <br />
          {{ d }}
        }
        @if (m.boughtPastMonth != null) {
          <br />
          先月販売数: {{ m.boughtPastMonth < 10 ? '9以下' : m.boughtPastMonth }}
        }
      </td>
      <td>
        @switch (m.amazonPriceSource) {
          @case ('current') {
            <span>Amazon: {{ m.amazonPrice | number }}</span>
          }
          @case ('last') {
            <span>Amazon: 出品者なし（最終 {{ m.amazonPrice | number }}円 {{ m.lastKnownPriceAt }}）</span>
          }
          @case ('stale') {
            <span>Amazon: -（1年より古い値しか無いので出しません）</span>
          }
          @default {
            <span>Amazon: {{ m.asin ? '出品者なし' : '-' }}</span>
          }
        }
        <br />
        仕入: {{ m.cost != null ? (m.cost | number) : '-' }}
      </td>
      <td [style.color]="m.fbaProfitPrice == null ? null : m.fbaProfitPrice < 0 ? 'red' : 'blue'">
        @if (m.fbaProfitPrice != null) {
          {{ m.fbaProfitPrice | number }}
          <br />
          {{ m.fbaProfitRate | percent: '1.1-1' }}
          @if (m.amazonPriceSource === 'last') {
            <br />
            <small>参考</small>
          }
        } @else {
          -
        }
      </td>
      <td>
        @if (m.asin) {
          <a
            [href]="'https://www.amazon.co.jp/dp/' + m.asin"
            target="_blank">
            {{ m.productName }}
          </a>
        } @else {
          <span class="text-600">らくじゃんに無い商品（JAN {{ m.jan }}）</span>
        }
        @if (m.line) {
          <div class="text-600 text-sm mt-1">
            {{ m.line }}
          </div>
        }
        @if (canDeleteReports && m.reportId != null) {
          <div class="mt-1">
            <button
              pButton
              type="button"
              data-testid="member-row-delete"
              class="p-button-sm p-button-text p-button-danger"
              pTooltip="同じ投稿が二重に入った時などに消します（管理人だけ）"
              tooltipPosition="top"
              (click)="onDeleteReport(m)">
              <i
                class="pi pi-trash"
                aria-hidden="true"></i>
              この報告を削除
            </button>
          </div>
        }
      </td>
    </tr>
  </ng-template>
</p-table>
<p-confirmdialog></p-confirmdialog>
